var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoal4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3543 15.4125 4.33008 4.12831V40.6161l20.02422 5.8786V15.4125Zm2.1479.0676v31.0146l20.1627-5.9462V4.12831L26.5022 15.4801ZM62.324 3.2499c0-1.28383-1.0393-2.297385-2.3558-2.297385-1.3164 0-2.3557 1.013555-2.3557 2.297385v2.50009h4.7115V3.2499Zm-4.088 36.6905h-.6235l2.3557 8.0408 2.3558-8.0408h-.5543.5543V7.50681h-4.7115V39.9404h.6235Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m50.9608 5.74992-2.148-1.68925V41.562l-22.2414 7.0273h-2.2172L2.18213 42.5756V4.06067L.0341797 5.74992V43.9945L24.2157 50.5488H26.71l22.2414-6.8921 2.0094-.6082V5.74992Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal4);
export default __webpack_public_path__ + "static/media/goal-4.03e301f274c53a27f10241c80e1d69b5.svg";
export { ForwardRef as ReactComponent };